import * as types from './company-context.types';
import * as constants from './company-context.constants';
import { ICompanyToolsCategory } from '../../resource/company-tools-category/company-tools-category.types';
import { ICompanyContext, ICompanyContextUpdate } from '../../resource/company-contexts/company-contexts.types';

export const initialCompanyContextPage = (): types.IInitialCompanyContextPage => ({
  type: constants.COMPANY_CONTEXT_PAGE,
});

export const createCompanyContext = (
  companyToolsCategoryId: ICompanyToolsCategory['id'],
): types.ICreateCompanyContext => ({
  type: constants.CREATE_COMPANY_CONTEXT,
  payload: { companyToolsCategoryId },
});

export const updateCompanyContext = (
  id: ICompanyContext['id'],
  data: ICompanyContextUpdate,
): types.IUpdateCompanyContext => ({
  type: constants.UPDATE_COMPANY_CONTEXT,
  payload: { id, data },
});

export const deleteCompanyContext = (id: ICompanyContext['id']): types.IDeleteCompanyContext => ({
  type: constants.DELETE_COMPANY_CONTEXT,
  payload: id,
});
